import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Icon from './assets/subway.svg';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Colored subway station icon
 */
export function SubwayIcon({ color, className }) {
  return (
    <span className={cx(className)} style={{ color }}>
      <Icon />
    </span>
  );
}

SubwayIcon.propTypes = {
  color: PropTypes.node,
  className: PropTypes.string,
};

/**
 * Subway station with name, properly indented and wrapped
 */
export function Subway({ children, color }) {
  return children ?
      <div className={cx('component')}>
        <SubwayIcon color={color} className={cx('icon')} />
        <span className={cx('title')}>{children}</span>
      </div>
    : null;
}

Subway.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
};
